import AuthService from '@/services/AuthService'
import { LOGIN, LOGOUT, NOT_AUTHENTICATED } from '../actions.type'
import { SET_AUTH, PURGE_AUTH } from '../mutations.type'
import router from '@/router'

const state = {
  isAuthenticated: !!sessionStorage.getItem('token'),
  user: JSON.parse(sessionStorage.getItem('user')) || {}
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  canEdit: state => state.user.role > 1,
  isAdmin: state => state.user.role > 2
}

const actions = {
  [LOGIN]: ({ commit }, { email, password }) => {
    return new Promise((resolve, reject) => {
      AuthService.userLogin(email, password)
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data && resp.data.data && !resp.data.data.error) {
              if (resp.data.data.token) {
                commit(SET_AUTH, resp.data.data)
                resolve()
              } else {
                reject('No authentication token returned. Please try again later.')
              }
            } else {
              reject(resp.data.data.error)
            }
          } else if (resp.data.data.error) {
            reject(resp.data.data.error)
          } else {
            reject('Unkonwn error')
          }
        })
        .catch(err => {
          reject(err.response.data.error)
        })
    })
  },
  [LOGOUT]: ({ commit }) => {
    commit(PURGE_AUTH)
  },
  [NOT_AUTHENTICATED]: ({ dispatch }) => {
    dispatch(LOGOUT)
    router.push('/login')
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_AUTH]: (state, { token, user }) => {
    state.isAuthenticated = true
    sessionStorage.setItem('token', token)
    state.user = {
      firstname: user.firstName,
      lastname: user.lastName,
      email: user.email,
      role: user.status
    }
    sessionStorage.setItem('user', JSON.stringify(state.user))
  },
  [PURGE_AUTH]: state => {
    state.isAuthenticated = false
    sessionStorage.removeItem('token')
    state.user = {}
    sessionStorage.removeItem('user')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
